/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbPcs_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly isVip: boolean | null;
    readonly " $refType": "PdpSharedBlurbPcs_user";
};
export type PdpSharedBlurbPcs_user$data = PdpSharedBlurbPcs_user;
export type PdpSharedBlurbPcs_user$key = {
    readonly " $data"?: PdpSharedBlurbPcs_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbPcs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVip",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '798cc2f7844edebce72ab120ee42ebdc';
export default node;
